import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ_ITEMS = [
  'overview',
  'add_location',
  'edit_boundary',
  'draw_drag',
  'intersection',
  'geohash_cells',
  'draw_road',
  'road_width',
  'save_road',
  'pending_routes',
  'route_visibility',
  'route_actions',
  'layers_assets',
  'undo_cancel',
] as const;

interface RoadsImporterFaqDialogProps {
  open: boolean;
  onClose: () => void;
}

export function RoadsImporterFaqDialog({
  open,
  onClose,
}: RoadsImporterFaqDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        {t('roads_importer_faq_title')}
      </DialogTitle>
      <DialogContent dividers sx={{ p: 2 }}>
        {FAQ_ITEMS.map((item) => (
          <Accordion
            key={item}
            disableGutters
            elevation={0}
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '8px',
              '&:before': { display: 'none' },
              '& + &': { mt: 1 },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                {t(`roads_importer_faq_${item}_question`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {t(`roads_importer_faq_${item}_answer`)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          size="small"
          onClick={onClose}
          sx={{ borderRadius: '8px', fontWeight: 600 }}
        >
          {t('roads_importer_btn_close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
